import { render, staticRenderFns } from "./DetalhesProdutoFilialDrp.vue?vue&type=template&id=6cf7e248&scoped=true"
import script from "./DetalhesProdutoFilialDrp.vue?vue&type=script&lang=js"
export * from "./DetalhesProdutoFilialDrp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf7e248",
  null
  
)

export default component.exports